import { OptionsViewModel } from '@models/common.models';

export interface CommentViewModel {
  commentId: number;
  entityId: number;
  entityDisplayName: string;
  comment: string;
  commentType: string;
  employee: OptionsViewModel;
  addedDate: Date;
  employees: Array<OptionsViewModel>;
  actionDate: string;
}

export enum CommentType {
  Customer = 'Customer',
  Contract = 'Contract',
  Swo = 'Swo',
  Vendor = 'Vendor'
}



// WEBPACK FOOTER //
// ./src/_models/Comment.ts